import { DialogComponent } from "./chunk-GQWK4RJY.js";
import { Heading_default } from "./chunk-JL63HSDD.js";
import { Spinner_default } from "./chunk-R5WT33YN.js";
import { noop } from "./chunk-KROBAS26.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/LoadingModal/LoadingModal.tsx
import { Dialog as HeadlessDialog } from "@headlessui/react";
import { jsx, jsxs } from "react/jsx-runtime";
var LoadingModal = _a => {
  var _b = _a,
    {
      isOpen,
      onClose,
      children,
      title,
      className
    } = _b,
    rest = __objRest(_b, ["isOpen", "onClose", "children", "title", "className"]);
  return /* @__PURE__ */jsxs(DialogComponent, __spreadProps(__spreadValues({
    isOpen,
    onClose: onClose || noop,
    className
  }, rest), {
    children: [/* @__PURE__ */jsx(DialogComponent.Backdrop, {
      className: ""
    }), /* @__PURE__ */jsx(DialogComponent.Front, {
      className: "pd-flex pd-items-center pd-justify-center pd-p-3",
      children: /* @__PURE__ */jsx(DialogComponent.Panel, {
        className: "pd-max-h-full pd-w-full pd-max-w-3xl pd-rounded",
        children: /* @__PURE__ */jsxs(DialogComponent.Content, {
          className: "pd-flex pd-flex-col pd-items-center pd-p-6 pd-text-center",
          children: [/* @__PURE__ */jsx(Spinner_default, {
            size: "lg",
            className: "pd-mb-5"
          }), /* @__PURE__ */jsx(Heading_default, {
            as: HeadlessDialog.Title,
            size: "3",
            className: "pd-mb-1",
            children: title
          }), children]
        })
      })
    })]
  }));
};
var LoadingModal_default = LoadingModal;
export { LoadingModal_default };